<template>
	<div class="text-align-center">
		<p class="body-md font-weight-bold">Average allocation to alternatives</p>
		<img
			v-lazy="alternativesAllocationPath"
			class="my-150 px-200-md"
			alt="Individuals hold 50% of the 275 to 295 trillion dollars of global assets under management, but represent just 16% of assets held by alternative investment funds."
		/>
		<p class="body-sm text-color-content-tertiary">Sources: Preqin; GlobalData; Bain analysis</p>
	</div>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const alternativesAllocationPath = computed((): string => {
	return `${appCloudfrontPath}/images/offerings/fundrise-ipo/average-allocation-to-alternatives${
		appStore.isMobile ? '-mobile' : ''
	}.png`;
});
</script>
